import { Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges, TemplateRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { CommonService } from 'src/app/_services/common.service';
import { DashboardService } from '../../services/dashboard.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { environment } from 'src/environments/environment';
import { NgNavigatorShareService } from 'ng-navigator-share';
import { ToastrService } from 'ngx-toastr';
import { TinyUrlService } from '../../services/tinyurl.service';
declare let gtag: Function;
declare let $: any;
@Component({
  selector: 'tangram-ratings',
  templateUrl: './ratings.component.html',
  styleUrls: ['./ratings.component.scss']
})
export class RatingsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() ratings: any;
  @Input() isDashboard: boolean;
  @Input() videoId;
  @Input() pathwayId: any;
  @Input() userRating: any;
  @Input() createdById: any;
  @Input() altPathId: any;
  @Input() isPrivate: boolean = false;
  @Input() completionPercentage: number = 0;
  @Input() completedVideoIds: string[] = [];
  @Input() currentVideoId: string = '';
  @Input() totalMediaCount: number = 0;
  @Output() showLoginAlert = new EventEmitter();
  @Output() toggleMediaCompletion = new EventEmitter<{ videoId: string, isCompleted: boolean }>();
  @ViewChild('EmbedModalPopupContent', { static: true }) embedModalPopupContent!: TemplateRef<any>;

  showCompletionDetails: boolean = false;

  shareUrl: string = '';
  shareVideoUrl: string = '';
  fbShareUrl: string = '';
  inAppShareUrl:string = '';
  whatsAppShareUrl: string = '';
  whatsAppShareUrl1: string = '';
  isBookmarked: boolean = false;

  // Star Rating properties
  userStarRating: number = 0;
  hoverStarRating: number = 0;
  averageStarRating: number = 0;
  totalStarRatings: number = 0;
  // Default to visible so the rating card (average + "your rating") shows
  // without needing to tap the star button first; the button still toggles it.
  showStarRatingPicker: boolean = true;
  iconPath = appConfig.iconPath;
  openTangramFooterSubScription: Subscription;
  currentUser: any;
  visibility: string = ""; // To check id public page or not
  private ngNavigatorShareService: NgNavigatorShareService;
  private iosReg : any;
  isIOS: boolean = false;
  isLightMode: boolean = false;
  // Base URL for embedded modal popup
  baseUrl: string = window.location.origin;
  
  
  // Embed modal properties
  // private andoiidReg : any;
  constructor(
    private dashboardService: DashboardService,
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private modalService: NgbModal,
    ngNavigatorShareService: NgNavigatorShareService,
    private tinyUrlService: TinyUrlService,
    private toasterService: ToastrService,

    ) {
      this.currentUser = this.authService.currentUserValue;
      this.ngNavigatorShareService = ngNavigatorShareService;
    }
    
  async ngOnInit() {
    //call subscription
    this.iosReg = /iphone|ipad/i;
    this.isIOS = this.iosReg.test(navigator.userAgent);
    this.isLightMode = localStorage.getItem('tangram_light_mode') === '1';
    // this.andoiidReg = /Mobile|Android/i;
    this.activatedRoute.params
      .subscribe(params => {
        // Build the share link from the current origin so it points at whatever
        // environment the app is actually running on (localhost / staging /
        // production) — not the hardcoded appRedirectUrl, which was always
        // staging in the dev build.
        this.shareUrl = window.location.origin + '/#/dashboard/' + params.pathwayId
      }
    );
    this.shareUrl = await this.shortenUrlFunc(this.shareUrl)
    // this.shareUrl = window.location.href;
    // this.shareUrl = this.shareUrl.split('/').splice()
    // urlArr.pop();
    


    if (this.activatedRoute.parent && this.activatedRoute.parent.snapshot && this.activatedRoute.parent.snapshot.routeConfig && this.activatedRoute.parent.snapshot.routeConfig.path === 'video/:id') {
      this.visibility = 'public';
    }
    this.shareVideoUrl = window.location.href.split('?')[0] + '?videoId=';
    this.fbShareUrl = environment.fbShareUrl;
    this.inAppShareUrl = environment.inAppShareUrl
    const details = navigator.userAgent;

    const regexp = /android|iphone|kindle|ipad/i;

    /* Using test() method to search regexp in details
    it returns boolean value*/
    const isMobileDevice = regexp.test(details);

    if (isMobileDevice) {
      this.whatsAppShareUrl=environment.whatsAppShareUrlMobile;
    } else {
      this.whatsAppShareUrl=environment.whatsAppShareUrl;
    }
    
    this.loadStarRating();

    this.openTangramFooterSubScription = this.commonService.openTangramFooterMenu.subscribe((_param: any) => {
      this.isLightMode = localStorage.getItem('tangram_light_mode') === '1';
    });
  }

  copyLink(type){
    // const content = document.getElementById('share-tangram-url').textContent;
    // loading the content into our clipboard
    let link = this.shareUrl;
    if (type === 'video') {
      link = this.shareVideoUrl;
    }
    navigator.clipboard.writeText(link);
  
  }

  async openSharePopup(type) {
    if(this.videoId){
      this.shareVideoUrl = await this.shortenUrlFunc(window.location.href.split('?')[0] + '?videoId=' + this.videoId)
    }
    // this.shareVideoUrl = environment.appRedirectUrl + '/#/dashboard/' + this.pathwayId + '?videoId=';
    const link = type !== 'video' ? this.shareUrl : (this.shareVideoUrl);
    // getElementById can be null (e.g. the input isn't rendered for private
    // tangrams where the share button is hidden), so guard before setting it.
    const urlInput = document.getElementById("share-tangram-url");
    if (urlInput) urlInput.setAttribute('value', link);
    const popup = document.getElementById("share-popup");
    const btnPopup = document.getElementById("shareBtn");
    if(this.isIOS){
      this.ngNavigatorShareService.share({
        title: '',
        // text: 'Sharing My tangram',
        url: link
      }).then( (response) => {
        console.log(response);
      })
      .catch( (error) => {
        console.log(error);
      })    
    }
    else{
      if(popup) {
        popup.classList.toggle("show");
      }
      if(btnPopup) {
        btnPopup.classList.toggle("visible");
      }
    }

  }

  /**
 * redirects user to share popup
 * @param link to be shared
 */
  shareRedirect(appUrl,link) {
    const shareURL = appUrl ? appUrl + encodeURIComponent(link) : link;
    window.open(shareURL,'popup','width=600,height=600'); 
    return false;
  }

  /**
   * Called once, before the instance is destroyed.
   */
  ngOnDestroy(): void {
    this.openTangramFooterSubScription ? this.openTangramFooterSubScription.unsubscribe() : '';
  }

  /**
   * open spotlight modal in mobile
   */
  openSpotLightModal() {
    this.commonService.openSpotLightModalFooter(true);
  }

  /**
   * Do like dislike and favourite video
   * @param currentStatus currentStatus to check current status
   * @param selectedType selectedType to check like, dislike or favorite
   */
  likeDislikeVideo(currentStatus, selectedType) {
    if (this.currentUser || this.visibility !== 'public') {
      const data: any = { videoId: this.videoId };
      const statusToChange = currentStatus ? null : true; // status to be changed
      // Bind update status based on current based on selected type to change
      if (selectedType === 'like') {
        alert('Like')
        data.isLiked = statusToChange;
      }
      else if (selectedType === 'dislike') {
        data.isDisliked = statusToChange;
      }
      else {
        data.isFavourite = statusToChange;
      }
      data.pathwayId = this.pathwayId;

      this.dashboardService.likeDislikeVideo(data).subscribe((_response: any) => {
        // Update count and active status based on current status
        if (data.isFavourite) {
          gtag('event', 'like_tangram', {
            'video_id': data.videoId,
          });
        }
        if (selectedType === 'like') {
          this.userRating.isLiked = data.isLiked;
          // Update likes if user liked it and remove likes if user unliked it
          this.ratings.likes += data.isLiked ? 1 : -1;
          // If user liked from dislike then remove dislikes
          if (this.userRating.isDisliked) {
            this.userRating.isDisliked = false;
            this.ratings.disLikes -= 1;
          }
        }
        else if (selectedType === 'dislike') {
          this.userRating.isDisliked = data.isDisliked;
          // Update dislikes if user disliked it and remove dislikes if user liked it
          this.ratings.disLikes += data.isDisliked ? 1 : -1;
          // If user disliked from like then remove likes
          if (this.userRating.isLiked) {
            this.userRating.isLiked = false;
            this.ratings.likes -= 1;
          }
        }
        else {
          this.userRating.isFavourite = data.isFavourite;
          this.ratings.favourites += data.isFavourite ? 1 : -1;
        }
      });
    } else {
      this.router.navigate(['/login']);
    }
  }

  bookmarkTangram(flag,modalContent: TemplateRef<any>) {
    if (!this.currentUser) {
      this.showLoginAlert.emit()
      return;
    }
    if(!this.currentUser.subscriptionActive){
      this.modalService.open(modalContent, { centered: true, windowClass : 'unlock-premium' })
      return ;
    }
    this.ratings.isBookmarked = flag;
    const data = {
      isBookmarked: flag,
      userId: this.currentUser._id,
      pathwayId: this.altPathId
    }
    this.dashboardService.bookmarkPathway(data).subscribe((_response: any) => {
    });
  }

  /**
   * Open share modal
   * @param content content to be displayed as modal
   */
  openShareModal(content) {
    this.modalService.open(content, { centered: true }).result.then(() => {
    }, () => {
    });
  }

  async shortenUrlFunc(longUrl) {
    try {
      const response: any = await this.tinyUrlService.shortenUrl(longUrl).toPromise();
      return response.data.tiny_url; // Return the shortened URL
    } catch (error) {
      console.error('Error occurred while shortening URL:', error);
      this.toasterService.error(error)
      return longUrl
    }
  }

  /**
   * Open embed modal
   */
  openEmbedModal() {
    this.modalService.open(this.embedModalPopupContent, {
      centered: true,
      windowClass: 'embed-modal-popup',
      size: 'lg'
    });
  }

  /**
   * Toggle star rating picker visibility
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.videoId && !changes.videoId.firstChange && changes.videoId.currentValue) {
      this.loadStarRating();
    }
    if (changes.isDashboard && !changes.isDashboard.firstChange) {
      this.loadStarRating();
    }
    // `altPathId` (the pathway id used by the tangram-view star rating) is
    // pushed in asynchronously — the parent only sets `pathwayId` once
    // getPathwayDetail() resolves, well after this component's ngOnInit. Its
    // first `loadStarRating()` therefore ran with an empty id and bailed out,
    // so without this the tangram view shows 0 even for a tangram the user
    // has already rated (making a saved rating look lost on reload). Reload
    // once the real id lands. (The synchronous case is still covered by
    // ngOnInit, which is why we skip firstChange here.)
    //
    // Gate on `isDashboard`: only the tangram view loads by pathway id. In
    // media view the loader uses `videoId` (handled above), and the parent
    // sets `isDashboard = false` synchronously before the pathway id arrives
    // — so without this guard a media-view page fired BOTH /star-rating (from
    // here) and /media-star-rating on a single load.
    if (this.isDashboard && changes.altPathId && !changes.altPathId.firstChange && changes.altPathId.currentValue) {
      this.loadStarRating();
    }
  }

  toggleStarRatingPicker() {
    // Guests may open the picker to see the average rating + count. The login
    // prompt is deferred to the moment they actually click a star to rate
    // (setUserStarRating) — opening the panel alone never asks them to log in.
    this.showStarRatingPicker = !this.showStarRatingPicker;
  }

  toggleCompletionDetails() {
    if (!this.currentUser) {
      this.showLoginAlert.emit();
      return;
    }
    if (this.isDashboard) {
      this.showCompletionDetails = !this.showCompletionDetails;
    } else {
      // Media view: toggle completion directly
      const isCompleted = this.completedVideoIds.includes(this.currentVideoId);
      this.toggleMediaCompletion.emit({ videoId: this.currentVideoId, isCompleted: !isCompleted });
    }
  }

  isCurrentMediaCompleted(): boolean {
    return this.completedVideoIds.includes(this.currentVideoId);
  }

  toggleMediaCompletionDirect(event: Event): void {
    event.preventDefault();
    if (!this.currentUser) {
      this.showLoginAlert.emit();
      return;
    }
    const isCompleted = this.isCurrentMediaCompleted();
    this.toggleMediaCompletion.emit({ videoId: this.currentVideoId, isCompleted: !isCompleted });
  }

  /**
   * Load star rating from API
   * Tangram view: pathway-level star rating (user's own rating + total)
   * Media view: rating for the current video
   */
  loadStarRating() {
    // No currentUser guard: the average rating + count are public and must
    // render for logged-out viewers too. The backend GET is optional-auth and
    // returns userRating: 0 for anonymous callers (submitting a rating is still
    // gated by currentUser in setUserStarRating — the login prompt fires only
    // when a guest actually clicks a star).
    if (this.isDashboard) {
      // Tangram view: show pathway-level star rating
      if (!this.altPathId) return;
      this.dashboardService.getStarRating(this.altPathId).subscribe((response: any) => {
        if (response.success) {
          this.userStarRating = response.data.userRating || 0;
          this.averageStarRating = response.data.averageRating || 0;
          this.totalStarRatings = response.data.totalRatings || 0;
        }
      });
    } else {
      // Media view: show rating for this specific video
      if (!this.videoId) return;
      this.dashboardService.getMediaStarRating(this.videoId).subscribe((response: any) => {
        if (response.success) {
          this.userStarRating = response.data.userRating || 0;
          this.averageStarRating = response.data.averageRating || 0;
          this.totalStarRatings = response.data.totalRatings || 0;
        }
      });
    }
  }

  /**
   * Set user star rating via API
   * Media view: rate the current video
   * Tangram view: rate the pathway (original behavior)
   */
  setUserStarRating(rating: number) {
    if (!this.currentUser) {
      this.showLoginAlert.emit();
      return;
    }

    if (!this.isDashboard && this.videoId) {
      // Media view: rate this specific video
      this.dashboardService.upsertMediaStarRating(this.videoId, this.altPathId, rating).subscribe((response: any) => {
        if (response.success) {
          this.userStarRating = response.data.userRating;
          this.averageStarRating = response.data.averageRating;
          this.totalStarRatings = response.data.totalRatings;
          // this.toasterService.success('Rating submitted!', 'Success');
        }
      }, (_error) => {
        this.toasterService.error('Failed to submit rating', 'Error');
      });
    } else {
      // Tangram view: rate the pathway
      this.dashboardService.upsertStarRating(this.altPathId, rating).subscribe((response: any) => {
        if (response.success) {
          this.userStarRating = response.data.userRating;
          this.averageStarRating = response.data.averageRating;
          this.totalStarRatings = response.data.totalRatings;
          // this.toasterService.success('Rating submitted!', 'Success');
        }
      }, (_error) => {
        this.toasterService.error('Failed to submit rating', 'Error');
      });
    }
  }

  getStarChar(isFilled: boolean): string {
    return isFilled ? '★' : '☆';
  }
}
